import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Components
import ReviewTemplateBuilderPage from 'Dashboard/components/ReviewTemplateBuilderPage/ReviewTemplateBuilderPage';
import ReviewTemplateBuilderPageV2 from 'Dashboard/components/ReviewTemplateBuilderPageV2/ReviewTemplateBuilderPage';

const FeedbackTemplateBuilderPage = () => {
  const { reviewTemplateBuilderV2 } = useFlags();

  if (reviewTemplateBuilderV2) return <ReviewTemplateBuilderPageV2 />;
  return <ReviewTemplateBuilderPage />;
};

export default FeedbackTemplateBuilderPage;
